package ui.theme

import org.jetbrains.compose.web.css.*

object AppShadows {
    // Standard Shadows
    val none = "none"
    val sm = "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
    val md = "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
    val lg = "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
    val xl = "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
    val xl2 = "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
    
    // Colored Shadows
    val primarySm = "0 1px 2px 0 ${AppColors.shadowPrimary}"
    val primaryMd = "0 4px 6px -1px ${AppColors.shadowPrimary}, 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
    val primaryLg = "0 10px 15px -3px ${AppColors.shadowPrimary}, 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
    val primaryXl = "0 20px 25px -5px ${AppColors.shadowPrimary}, 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
    
    // Glassmorphism Shadows
    val glass = """
        0 8px 32px rgba(15, 23, 42, 0.08),
        0 1px 1px rgba(255, 255, 255, 0.15),
        inset 0 1px 0 ${AppColors.glassHighlight},
        inset 0 -1px 0 rgba(0, 0, 0, 0.05)
    """.trimIndent()
    
    val glassHover = """
        0 20px 40px rgba(15, 23, 42, 0.12),
        0 8px 16px ${AppColors.shadowPrimary},
        inset 0 1px 0 rgba(255, 255, 255, 0.25),
        inset 0 -1px 0 rgba(0, 0, 0, 0.1)
    """.trimIndent()
    
    val glassPressed = """
        0 4px 8px rgba(15, 23, 42, 0.15),
        inset 0 2px 4px rgba(0, 0, 0, 0.1),
        inset 0 -1px 0 rgba(255, 255, 255, 0.1)
    """.trimIndent()
    
    // Neomorphism Shadows
    val neomorphSm = """
        2px 2px 4px ${AppColors.shadowDark},
        -2px -2px 4px ${AppColors.shadowLight}
    """.trimIndent()
    
    val neomorphMd = """
        4px 4px 8px ${AppColors.shadowDark},
        -4px -4px 8px ${AppColors.shadowLight}
    """.trimIndent()
    
    val neomorphLg = """
        8px 8px 16px ${AppColors.shadowDark},
        -8px -8px 16px ${AppColors.shadowLight}
    """.trimIndent()
    
    val neomorphInset = """
        inset 2px 2px 4px ${AppColors.shadowDark},
        inset -2px -2px 4px ${AppColors.shadowLight}
    """.trimIndent()
    
    // Animation Shadows
    val floatingCard = """
        0 8px 25px rgba(139, 92, 246, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.15)
    """.trimIndent()
    
    val floatingCardHover = """
        0 12px 30px rgba(139, 92, 246, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.25)
    """.trimIndent()
    
    // Glow Effects
    val glowPrimary = "0 0 20px ${AppColors.shadowPrimary}"
    val glowSecondary = "0 0 20px rgba(168, 85, 247, 0.25)"
    val glowSuccess = "0 0 20px rgba(16, 185, 129, 0.25)"
    val glowError = "0 0 20px rgba(239, 68, 68, 0.25)"
}
